module.exports = __webpack_public_path__ + "img/swish.63608cc3.jpg";